export function calculateElementHeight(element: HTMLElement) {
  return element.clientHeight;
}
